/** 逻辑 field key，供 accessPolicy / registerCapability.fields 使用 */
export const STORAGE_FIELD_KEYS = {
  list: 'storage.list',
} as const;

export const STORAGE_FIELD_KEY_LIST = [STORAGE_FIELD_KEYS.list] as const;

/** 数据盘操作（与 image-vm 的 systemDisk.* 命名空间隔离） */
export const STORAGE_ACTION_KEYS = {
  add: 'dataDisk.add',
  select: 'dataDisk.select',
  edit: 'dataDisk.edit',
  remove: 'dataDisk.remove',
} as const;

export const STORAGE_ACTION_KEY_LIST = Object.values(STORAGE_ACTION_KEYS);
